import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=29aa4cc2&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=29aa4cc2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa4cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29aa4cc2')) {
      api.createRecord('29aa4cc2', component.options)
    } else {
      api.reload('29aa4cc2', component.options)
    }
    module.hot.accept("./ArticleCard.vue?vue&type=template&id=29aa4cc2&scoped=true", function () {
      api.rerender('29aa4cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/ArticleCard.vue"
export default component.exports